import React, {useState, useEffect} from "react";
import { SBDatePicker } from "../../../UiComponents/SBDatePicker";
import { SBAComboBox } from "../../../UiComponents/SBADropDown";
import { sbaAxios } from "../../../utils/sbaAxios";
import moment from "moment";
import {
    showAllPortfolios,
    getPortfolioAssets,
    loadValuations
} from "../../../../config/apiConfig";
import { toast } from "react-toastify";

function LoadValuations(){
    const fromDateSetter = () => {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), 1);
    }
    const [fromDate, setFromDate] = useState(fromDateSetter());
    const [toDate, setToDate] = useState(new Date());
    const [portfolioList, setPortfolioList] = useState([]);
    const [selectedPortfolio, setSelectedPortfolio] = useState(null);
    const [selectedPortfolioId, setSelectedPortfolioId] = useState(0);
    const [assetList, setAssetList] = useState([]);
    const [selectedAsset, setSelectedAsset] = useState(null);
    const [selectedAssetId, setSelectedAssetId] = useState(0);


    useEffect(()=>{
        const fetchPortfolios = async()=>{
            try{
                const list = await sbaAxios({
                    url: `${showAllPortfolios}/${true}`,
                    method: "get",
                })
                setPortfolioList(list)
            }
            catch(e){
                setPortfolioList([])
            }
        };
        fetchPortfolios();
    },[]);

    useEffect(()=>{
        const fetchNewAssets = async() => {
            try{
                const list = await sbaAxios({
                    url:getPortfolioAssets,
                    params:{
                        portfolioId: selectedPortfolioId
                    }
                });
                setAssetList(list);
            }
            catch(e){
                setAssetList([])
            }
        };
        if(selectedPortfolioId !== 0){
            fetchNewAssets();
        }
    },[selectedPortfolioId]);

    const handleSelectedPortfolio = (e) => {
      setSelectedPortfolio(e.value);
      setSelectedPortfolioId(e.value.PortfolioId);
    };

    const handleSelectedAsset = (e) => {
      setSelectedAsset(e.value);
      setSelectedAssetId(e.value.AssetId);
    };

    const dateFormatter = (date) => {
        if (typeof date.toDate === 'function') {
            date = date.toDate(); 
        }
        if (!(date instanceof Date) || isNaN(date)) {
            throw new Error("Invalid date provided");
        }
        let month = String(date.getMonth() + 1).padStart(2, '0');
        let day = String(date.getDate()).padStart(2, '0');
        let year = date.getFullYear();

        return `${month}-${day}-${year}`;
    };

    const handleLoadvaluations = async() => {
      console.log('Loading Valuations');
      const response = await sbaAxios({
        url: loadValuations,
        params:{
            portfolioId: selectedPortfolioId,
            assetId: selectedAssetId,
            fromDate: dateFormatter(fromDate),
            toDate: dateFormatter(toDate)
        },
        method: 'post'
      });
      console.log(response);
      if(response){
        toast.success('Valuations loaded successfully.')
      }
      else{
        toast.error('Unable to load valuations.')
      }
    };

    return(
        <>
        <div className="container-fluid">
            <div className="row mt-2">
                <div className="col-md-4">
                    <label className="label">From Date</label>
                    <div style={{width:'450px'}}>
                        <SBDatePicker 
                            value={moment(fromDate)} 
                            onChange={(newDate)=>{setFromDate(newDate)}}
                            minDate={moment(fromDateSetter())}
                            sx={{width:'100%'}}
                        />
                    </div>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-md-4">
                    <label className="label">To Date</label>
                    <div style={{width:'450px'}}>
                        <SBDatePicker  
                            value={moment(toDate)} 
                            onChange={(newDate)=>{setToDate(newDate)}}
                            minDate={moment(toDate)}
                            sx={{width:'100%'}}
                        />
                    </div>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-md-4">
                    <label className="label" >Portfolio</label>
                    <div style={{width:'450px'}}>
                        <SBAComboBox
                            data={portfolioList}
                            textField={"PortfolioName"}
                            valueField={"PortfolioId"}
                            value={selectedPortfolio}
                            onChange={handleSelectedPortfolio}
                            popupSettings={{ className: "modalDD" }}
                        ></SBAComboBox>
                    </div>
                </div>
            </div>
            <div className="row mt-4 mb-2">
                <div className="col-md-4">
                    <label className="label" >Asset</label>
                    <div style={{width:'450px'}}>
                        <SBAComboBox
                            data={assetList}
                            textField={"AssetName"}
                            valueField={"AssetId"}
                            value={selectedAsset}
                            onChange={handleSelectedAsset}
                            popupSettings={{ className: "modalDD" }}
                        ></SBAComboBox>
                    </div>
                </div>
            </div>
            <div className="row mt-1">
                <div className="col-md-4">
                    <div className="m-1 d-flex justify-content-end mt-1" style={{width:'450px'}}>
                        <button className="p-sm-btn mx-1" onClick={handleLoadvaluations}>Load Valuations</button>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default LoadValuations;